import type {IconName} from '@/components/common/Icon';
import type {ProjectId} from '@/types';

export interface AssetTabItem {
    key: string;
    label: string;
    /** 该 Tab 下的二级 Tab */
    subTabItems?: AssetTabItem[];
}

export interface AssetConf {
    navItems?: AssetTabItem[];
}

export interface HomeInfoData {
    /** 平台使用人数 */
    activeUsers: number;
    /** 创作入口配置 */
    entryConf: CreationConfItem[];
    /** 资产页 Tab 配置，未返回时使用写死兜底 */
    assetConf?: AssetConf;
    /** 爆款案例 */
    hitCases: HotCase[];
    /** 我的项目 */
    myProjects: MyProject[];
    /** 反馈二维码 */
    qrCode?: string;
    /** 举报与反馈邮箱 */
    email?: string;
    /** 官方企微二维码 */
    contactQrCode: string;
}

/** 项目名称重复校验请求参数 */
export interface CheckProjectNameReq {
    /** 项目名称 */
    projectName: string;
}

/** 项目名称重复检验返回结果 */
export interface CheckProjectNameData {
    /** 是否已存在 */
    exists: boolean;
}

export const CreationEntry = {
    AI_DRAMA: 'ai_drama',
    SCRIPT: 'script',
    MATERIAL: 'material',
} as const;

export type CreationEntryType = (typeof CreationEntry)[keyof typeof CreationEntry];

export interface CreationConfItem {
    /** 创作类型标识，用于前端匹配交互行为 */
    type: CreationEntryType;
    /** 图标名称 */
    iconName: IconName;
    /** 主标题 */
    title: string;
    /** 副标题 */
    subTitle: string;
    /** 展示敬请期待标签，同时表示该功能尚未上线 */
    showComingSoon?: boolean;
}

export interface HotCase {
    /** 封面地址 */
    coverUrl: string;
    /** 案例标题 */
    title: string;
    /** 视频地址 */
    videoUrl: string;
    /** 剧情类型 */
    tags?: string[];
}

export interface Project {
    /** 项目id */
    projectId: ProjectId;
    /** 项目名称 */
    projectName: string;
    /** 封面地址 */
    coverUrl: string;
    /** 集数 */
    scriptCount?: number;
    /** 创建时间 */
    createdTime: string;
    /** 更新时间 */
    updatedTime: string;
    /** 是否是创建人 */
    isOwner: boolean;
}

export type MyProject = Project &
    (
        | {
              /** 是否为案例项目 */
              isCase: true;
              /** 视频地址，案例项目会有此字段 */
              videoUrl: string;
              /** 案例副标题 */
              subTitle?: string;
          }
        | {isCase?: false; videoUrl?: never}
    );

/** 漫剧类型：1-对话型 2-旁白型 */
export const ComicType = {
    DIALOGUE: 1,
    NARRATION: 2,
} as const;

export type ComicTypeValue = (typeof ComicType)[keyof typeof ComicType];

/** 新建项目请求参数 */
export interface CreateProjectReq {
    /** 项目名称 */
    projectName: string;
    /** 项目封面URL */
    projectCover?: string;
    /** 积分预算，默认0 */
    pointBudget: number;
    /** 交付日期，格式：yyyy-MM-dd */
    deliveryDate: string;
    /** 漫剧类型 */
    comicType: ComicTypeValue;
}
